module.exports = __webpack_public_path__ + "static/media/create2.2132a54a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/views/Tutorial/screenshots/Creating/create2.jpg
// module id = 1619
// module chunks = 0